import React from 'react';
import { StyledHomeColumns } from './StyledHomeColumns';


const HomeColumns = ({entries, separators}) => {

  return (
    <React.Fragment>
      {
       
          <StyledHomeColumns>
            {
              entries.map((entry, i) => {
                return  <div className="home--col" key={i}>
                          <p className="preset-10" dangerouslySetInnerHTML={{__html: entry.title}}></p>
                          {!separators && <br />}
                          {separators && <div className="col-separator"></div>}
                          <p className="preset-12 grey">{entry.text}</p>
                        </div>
              })
            }
          </StyledHomeColumns>
          
      }
    </React.Fragment>
  );
};

export default HomeColumns;
